import React from "react";
import "./CheckoutProducts.css";
import { useStateValue } from "./StateProvider";
import DeleteIcon from "@material-ui/icons/Delete";

const CheckoutProducts = ({ title, image, price, rating }) => {
	let arrstar = [];
	for (let i = 0; i < rating; i++) {
		arrstar.push(1);
	}

	const [{ basket }, dispatch] = useStateValue();

	const removeFromBasketHandler = () => {
		dispatch({
			type: "REMOVE_FROM_BASKET",
			title: title,
		});
	};

	return (
		<div className="grid__container">
			<div className="checkoutProduct">
				<img className="checkoutProduct__img" src={image} alt={title} />

				<div className="checkoutProduct__info">
					<p className="checkoutProduct__title">
						{title.slice(0, 120)}
						{title.length > 120 ? "..." : ""}
					</p>
					<p className="checkoutProduct__price">
						<small>₹</small> <strong>{price}</strong>
					</p>
					<div className="checkoutProduct__rating">
						{arrstar.map((star) => (
							<p>⭐️</p>
						))}
					</div>
					<button
						className="button__container"
						onClick={removeFromBasketHandler}
					>
						<DeleteIcon className="product__buttonIcon" />
						Remove item
					</button>
				</div>
			</div>
		</div>
	);
};

export default CheckoutProducts;
